import { useState } from "react";
import { Footer } from "./leftSideBar/Footer";
import { Logout } from "./leftSideBar/Logout";
import { MenuContainer } from "./leftSideBar/MenuContainer";
import { UserContainer } from "./leftSideBar/UserContainer";

export const SidebarPanel = (props: SidebarPanelProps) => {
  const [internalIsExpanded, setInternalIsExpanded] = useState(
    props.defaultExpanded ?? true,
  );
  const isExpanded = props.isExpanded ?? internalIsExpanded;
  const setIsExpanded = props.setIsExpanded ?? setInternalIsExpanded;

  return (
    <div className={`sidebar-panel ${props.className ?? ""}`}>
      <UserContainer isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      <MenuContainer isExpanded={isExpanded} onNavigate={props.onNavigate} />
      <Logout isExpanded={isExpanded} />
      {isExpanded && <Footer />}
    </div>
  );
};

interface SidebarPanelProps {
  className?: string;
  defaultExpanded?: boolean;
  isExpanded?: boolean;
  setIsExpanded?: (isExpanded: boolean) => void;
  onNavigate?: () => void;
}
